import PropTypes from 'prop-types';
// @flow

import React, { Component } from 'react';

// -- tools
import ViewUtils from 'PMT/utils/ViewUtils';

class ColorPickerColorView extends Component {

  static propTypes = {
    color: PropTypes.number.isRequired, // uint color

    onClicked: PropTypes.func.isRequired,

    isSelected: PropTypes.bool.isRequired
  };

  onColorClicked = () => {
    this.props.onClicked(this.props.color);
  };

  render() {
    const style = {
      background: ViewUtils.uintColorToRgbaFormat(this.props.color)
    };

    let selectedView = (<span className="color_picker__color_view__not_selected" />);

    if (this.props.isSelected) {
      // Setup the check icon color according to the color background.
      let colorClass = 'color_picker__color_view__color_light';
      if (ViewUtils.isLightColor(this.props.color)) {
        colorClass = 'color_picker__color_view__color_dark';
      }
      selectedView = (
        <span className="color_picker__color_view__selected">
          <i className={`fa fa-check-circle ${colorClass}`} />
        </span>
      );
    }

    return (
      <span
        className="color_picker__color_view pointer"
        onClick={this.onColorClicked}
        style={style}
      >
        <span className="color_picker__color_view__color vcenter" style={style}>
          {selectedView}
        </span>
      </span>
    );
  }

}

export default ColorPickerColorView;
